import {$oauth2} from './oauth2.js'
import {handleError, handleResponse} from '../fetch-api/handle-error.js'
const encoding = require('../utils/encoding.js')
const cookie = require('../utils/cookie.js')
const sha256 = require('js-sha256').sha256

function getProtocol() {
  const arr = window.location.href.split('/')
  return arr[0]
}
export function getHost() {
  const arr = window.location.href.split('/')
  return arr[2].split(':')[0]
}
export function getRedirectUrl(path = '') {
  const arr = window.location.href.split('/')
  return arr[0] + '//' + arr[2] + process.env.BASE_URL + path
}

function toUTF8Array(str) {
    var utf8 = [];
    for (var i=0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
            utf8.push(0xc0 | (charcode >> 6),
                0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
            utf8.push(0xe0 | (charcode >> 12),
                0x80 | ((charcode>>6) & 0x3f),
                0x80 | (charcode & 0x3f));
        }
        // surrogate pair
        else {
            i++;
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charcode = 0x10000 + (((charcode & 0x3ff)<<10)
                | (str.charCodeAt(i) & 0x3ff))
            utf8.push(0xf0 | (charcode >>18),
                0x80 | ((charcode>>12) & 0x3f),
                0x80 | ((charcode>>6) & 0x3f),
                0x80 | (charcode & 0x3f));
        }
    }
    return utf8;
}

export function redirectAuthUrl(oauth2 = {}, instId, extra = {}) {
    const env = oauth2[process.env.NODE_ENV]
      ? oauth2[process.env.NODE_ENV]
      : oauth2
    var authUrl = getProtocol() + '//' + getHost() + (env['authPort'] ? ':' + env['authPort'] : '') + env['authPath']
    const codeChallenge = oauth2.name + '-' + oauth2.codeChallengeMethod + '-' + 'codeChallenge'
    const inst = oauth2.inst.find(i => i.instId === instId)
    const clientId = cookie.hasValue($oauth2.apidName(), { path: process.env.BASE_URL })
      ? $oauth2.getValue($oauth2.apidName(), { path: process.env.BASE_URL })
      : (inst ? inst.clientId : oauth2.clientId)
    const state = Math.random().toString(36).substr(2, 10)
    cookie.setValue($oauth2.oastName(), state)
    // const shaCodeChallenge = btoa(Array.from(new Uint8Array(sha256.array(new TextEncoder('utf-8').encode(codeChallenge)))).map(byte => String.fromCharCode(byte)).join(''))
    const shaCodeChallenge = btoa(Array.from(new Uint8Array(sha256.array(toUTF8Array(codeChallenge)))).map(byte => String.fromCharCode(byte)).join(''))
    const query = {
      client_id: clientId,
      scope: oauth2.scope,
      state: state,
      redirect_uri: getRedirectUrl(oauth2.redirectPath),
      code_challenge_method: oauth2.codeChallengeMethod,
      code_challenge: shaCodeChallenge,
        ...extra
    }
    const redirectUrl = authUrl + '?' + encoding.encodeComponent(query)
    // console.debug('OAUTH2 URL: ' + redirectUrl)
    return redirectUrl
}

export function handleAuthQuery(oauth2 = {}, query = {}) {
  // console.debug('HANDLE OAUTH2 QUERY: ' + query)
  return new Promise((resolve, reject) => {
    const state = cookie.getValue($oauth2.oastName())
    const code = query.code
    if (!code) {
      reject({
        status: query.state,
        message: 'Authorization error: wrong code=' + code
      })
    } else if (code === 'NOSIGN') {
      reject({
        status: query.state,
        message: 'Authorization returned code=' + code
      })
    } else if (query.state !== state) {
        reject({
            status: query.state,
            message: 'Authorization error: wrong state=' + query.state
        })
    } else {
      const codeChallenge = oauth2.name + '-' + oauth2.codeChallengeMethod + '-' + 'codeChallenge'
      resolve($oauth2.getAuthToken(oauth2.clientId, code, oauth2.scope, codeChallenge))
    }
  })
}
